<template>
    <td-dialog
        :title="$t(title)"
        :before-close="modifyOrgDialogClose"
        :visible.sync="modifyOrgAvailable"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="modifyDialogWidth + 'px'"
    >
        <div>
            <component
                v-bind:is="currentTabComponent"
                @modifyOrgDialogClose="modifyOrgDialogClose"
                :editItem="editItem"
                :isAddData="false"
                :tabOptions="tabOptions"
                :selectType="selectType"
                :extendGroupFlg="extendGroupFlg"
                :loading="loading"
                @beforeSubmitForm="beforeSubmitForm"
                @validateSubmitFormFail="validateSubmitFormFail"
                ref="modifyOrgComponent"
            >
            </component>
        </div>
        <span slot="footer">
            <td-button type="primary" :loading="loading" @click="submitForm">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import orgApi from './../assets/api.js';
export default {
    name: 'tableIndex',
    props: {
        /* 编辑时，表单域标签的宽度设置 */
        modifyDevInfoFormLabelWidth: {
            type: [Number, String],
            default: function() {
                return 100;
            }
        },
        /* 编辑dialog宽度设置 */
        modifyDialogWidth: {
            type: [Number, String],
            default: function() {
                return 650;
            }
        },
        title: {
            type: [String, Number]
        },
        modifyOrgAvailable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        editItem: {
            trpe: Object,
            default: function() {
                return null;
            }
        },
        // 类型信息数据
        tabOptions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        //扩展组标识
        extendGroupFlg: {
            type: String
        },
        // 添加的paneName数据
        modifyPaneName: {
            type: Object,
            default: function() {
                return null;
            }
        },
        /* 当前选中的组织类型 */
        selectType: {
            type: Number,
            default: function() {
                return 0;
            }
        }
    },

    data() {
        return {
            hight: 100,
            loading: false
        };
    },

    computed: {
        currentTabComponent: function() {
            // 路径不支持动态
            return this.modifyPaneName;
        }
    },

    methods: {
        // 提交数据
        submitForm() {
            this.loading = true;
            this.$refs.modifyOrgComponent.submitForm();
        },
        // 表单验证失败
        validateSubmitFormFail() {
            this.loading = false;
        },
        // 提交数据
        beforeSubmitForm(content) {
            if (content === null || content === '' || content === undefined) {
                this.$message({ type: 'error', showClose: true, message: this.$t('pgMessage.CALLBACK_PARAM_NULL') });
            }
            orgApi.updateOrg(JSON.stringify(content), response => {
                this.loading = false;
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('orgApi.updateOrg', response);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                this.$emit('reciveOrgInfoFromDialog', content, this.editBaseOrg);
                this.modifyOrgDialogClose();
            });
        },

        // 取消
        cancel() {
            this.modifyOrgDialogClose();
        },

        // 关闭窗口之前需要调用的方法
        modifyOrgDialogClose() {
            this.$emit('modifyOrgDialogClose');
            this.editItem = null;
            this.modifyPaneName = null;
        }
    }
};
</script>

<style scoped>
>>> .el-tabs__header {
    margin-bottom: 0px;
}
</style>
